import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function PrivacyPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="wrapper">
        <button className="back-btn" onClick={() => navigate('/')}>← Back to Home</button>

        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-effective">Effective Date: January 1, 2026</p>

        <div className="legal-content">

          <section>
            <h2>1. Introduction</h2>
            <p>
              Deutsche Business Solutions, Inc. ("DBS," "we," "us," or "our") is committed to
              protecting your personal information and your right to privacy. This Privacy Policy
              explains how we collect, use, disclose, and safeguard your information when you
              visit our website or use our services.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
              <li>
                <strong>Personal Identification Information:</strong> Name, email address, phone
                number, company name, and other contact details you provide when reaching out to us
                or booking a consultation.
              </li>
              <li>
                <strong>Business Information:</strong> Details about your company, business
                processes, and operational needs shared for the purpose of delivering our services.
              </li>
              <li>
                <strong>Usage Data:</strong> Information about how you interact with our website,
                including IP address, browser type, pages visited, and time spent on pages.
              </li>
              <li>
                <strong>Communication Data:</strong> Records of correspondence between you and our
                team, including emails and messages.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>DBS uses the information we collect to:</p>
            <ul>
              <li>Provide, operate, and maintain our services</li>
              <li>Process inquiries, bookings, and service requests</li>
              <li>Communicate with you about service updates, offers, and support</li>
              <li>Improve our website and service offerings</li>
              <li>Comply with legal obligations</li>
              <li>Prevent fraudulent or unlawful activity</li>
            </ul>
          </section>

          <section>
            <h2>4. Sharing of Information</h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. We may
              share your information only in the following circumstances:
            </p>
            <ul>
              <li>
                <strong>Service Providers:</strong> With trusted third-party vendors who assist us
                in operating our website or delivering services, under strict confidentiality
                agreements.
              </li>
              <li>
                <strong>Legal Requirements:</strong> When required by law, regulation, or legal
                process.
              </li>
              <li>
                <strong>Business Transfers:</strong> In the event of a merger, acquisition, or
                sale of assets, your information may be transferred as part of that transaction.
              </li>
            </ul>
          </section>

          <section>
            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect
              your personal information against unauthorized access, alteration, disclosure, or
              destruction. These measures include secure servers, encrypted communications, and
              restricted access to personal data by our staff.
            </p>
            <p>
              However, no method of transmission over the internet is 100% secure, and we cannot
              guarantee the absolute security of your data.
            </p>
          </section>

          <section>
            <h2>6. Data Retention</h2>
            <p>
              We retain your personal data only for as long as necessary to fulfill the purposes
              outlined in this Privacy Policy, unless a longer retention period is required or
              permitted by law. Once your data is no longer needed, we will securely delete or
              anonymize it.
            </p>
          </section>

          <section>
            <h2>7. Cookies and Tracking Technologies</h2>
            <p>
              Our website may use cookies and similar tracking technologies to enhance your
              browsing experience. Cookies are small data files stored on your device. You may
              choose to disable cookies through your browser settings; however, this may affect
              certain features of our website.
            </p>
          </section>

          <section>
            <h2>8. Your Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul>
              <li>Access the personal data we hold about you</li>
              <li>Request correction of inaccurate or incomplete data</li>
              <li>Request deletion of your personal data</li>
              <li>Object to or restrict the processing of your data</li>
              <li>Withdraw consent at any time where processing is based on consent</li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at the details provided below.
            </p>
          </section>

          <section>
            <h2>9. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites. We are not responsible for
              the privacy practices or content of those websites. We encourage you to review the
              privacy policies of any third-party sites you visit.
            </p>
          </section>

          <section>
            <h2>10. Children's Privacy</h2>
            <p>
              Our services are not directed to individuals under the age of 18. We do not
              knowingly collect personal information from minors. If we become aware that a minor
              has provided us with personal data, we will take steps to delete such information
              promptly.
            </p>
          </section>

          <section>
            <h2>11. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on
              this page with an updated effective date. We encourage you to review this policy
              periodically to stay informed about how we protect your information.
            </p>
          </section>

          <section>
            <h2>12. Contact Us</h2>
            <p>
              If you have questions or concerns about this Privacy Policy or our data practices,
              please contact us:
            </p>
            <p>
              <strong>Deutsche Business Solutions, Inc.</strong><br />
              Email: info@deutschesolutions.com<br />
              Website: www.deutschesolutions.com
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;